import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from '../../../_services/GlobalService';
import { Commande } from '../../../_models/Commande';
import { ClientService } from '../../../_services/ClientService';
import { Client } from '../../../_models/Client';
import { NgForm } from '@angular/forms';
import { CategorieAnimalService } from '../../../_services/CategorieAnimalService';
import { CategorieAnimal } from '../../../_models/CategorieAnimal';
import { SocieteService } from '../../../_services/SocieteService';
import { SiteCabinetVeterinaire } from '../../../_models/SiteCabinetVeterinaire';
import { CommandeService } from '../../../_services/CommandeService';
import { TabStripComponent } from '@progress/kendo-angular-layout';
import { TypeCremationService } from '../../../_services/TypeCremationService';
import { TypeCremation } from '../../../_models/TypeCremation';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { State, process } from '@progress/kendo-data-query';
import { ReponseAPI } from '../../../_models/ReponseAPI';
import { TokenService } from '../../../_services/token.service';
import { StatutCommandeService } from '../../../_services/StatutCommandeService';
import { DataModelGetSites } from '../../../_models/DataModelController/DataModelGetSites';
import { Sac } from '../../../_models/Sac';
import { SacService } from '../../../_services/SacService';
import { DemandeSac } from '../../../_models/DemandeSac';
import { Asso_StatutCommande_Commande } from '../../../_models/Asso_StatutCommande_Commande';
import { DialogCloseResult, DialogService } from '@progress/kendo-angular-dialog';
import { StatutCommande } from '../../../_models/StatutCommande';
import { DataModelUpdateStatutAdmin } from '../../../_models/DataModelController/DataModelUpdateStatutAdmin';
import { AnimalService } from '../../../_services/AnimalService';
import { CauseDecesAnimal } from '../../../_models/CauseDecesAnimal';


@Component({
  selector: 'app-commande-view',
  templateUrl: './commande-view.component.html',
  styleUrls: ['./commande-view.component.scss']
})
export class CommandeViewComponent implements OnDestroy, OnInit {


  @ViewChild('tabstrip') tabstrip!: TabStripComponent;
  @Input() public commande!: Commande;
  @Input() public nouveau!: Boolean;
  public selectedTab: number = 0;
  public Clients: Client[] = new Array()
  public CategoriesAnimal: CategorieAnimal[] = new Array()
  @ViewChild('infoForm') infoFormSubmit!: NgForm;
  public verifFormInformation: boolean = true;
  messageErreurInformationSupprimerEtat: string = "";
  messageErreurInformation: string = "";
  loading: boolean = false;
  public AllClients: Array<Client> = new Array();
  public AllCategoriesAnimal: CategorieAnimal[] = new Array()
  public Sacs: Sac[] = new Array()
  public filteredSacs : Sac[] =  new Array()
  public EtablissementVeterinaires: SiteCabinetVeterinaire[] = new Array()
  public AllEtablissementVeterinaires: SiteCabinetVeterinaire[] = new Array()
  public Sexes: string[] = ["Mâle", "Femelle"]
  public IndexTabStrip = 0;
  TypesCremation: TypeCremation[] = new Array()
  IsAjouterStatut: boolean = false
  AllStatuts: StatutCommande[] = new Array()
  StatutSelect: StatutCommande = new StatutCommande()
  AllCausesDecesAnimal: CauseDecesAnimal[] = new Array()
  CauseDecesAnimal: CauseDecesAnimal = new CauseDecesAnimal()

  public gridData!: GridDataResult;
  public gridState: State = {
    skip: 0,
    take: 50,
  };

  lblTypeCremation: string = "Type de crémation initial *";

  public constructor(public _GlobalService: GlobalService,
    private _ClientService: ClientService,
    private _CategorieAnimalService: CategorieAnimalService,
    private _CabinetVeterinaireService: SocieteService,
    private _CommandeService: CommandeService,
    private _TypeCremationService: TypeCremationService,
    private _TokenService: TokenService,
    private _SacService: SacService,
    private _StatutCommandeService: StatutCommandeService,
    private _dialogService: DialogService,
    private _animalService:AnimalService

  ) { }

  async ngOnInit(): Promise<void> {
    this.loading = true;

    let data: DataModelGetSites = new DataModelGetSites();
    data.raccourci = false;
    data.utilisateurId = "";

    if (this._GlobalService.isAdmin()) {
      this.EtablissementVeterinaires = (await this._CabinetVeterinaireService.GetAllSitesOptimise(data)).objet
    } else {
      data.utilisateurId = this._GlobalService.utilisateur?.id!
      this.EtablissementVeterinaires = (await this._CabinetVeterinaireService.GetAllSitesOptimise(data)).objet
    }

    this.CategoriesAnimal = (await this._CategorieAnimalService.getAllCategories()).objet
    this.Clients = (await this._ClientService.GetAllClients()).objet
    this.TypesCremation = (await this._TypeCremationService.getAllTypes()).objet
    this.AllCausesDecesAnimal = (await this._animalService.getAllCausesDeces()).objet

    this.Clients = this.Clients.map(client => ({
      ...client,
      PrenomNom: `${client.prenom}-${client.nom}`
    }));

    this.EtablissementVeterinaires = this.EtablissementVeterinaires.map(etablissement => ({
      ...etablissement,
      CabinetVille: `${etablissement.cabinetVeterinaire.nom} ${etablissement.ville}`
    }));

    this.commande.asso_StatutCommande_Commande = this.commande.asso_StatutCommande_Commande.map(statutCommande => ({
      ...statutCommande,
      date: new Date(statutCommande.date)
    })).sort((a, b) => { return a.date > b.date ? 1 : -1 });

    this.EtablissementVeterinaires = this.EtablissementVeterinaires.filter(x => x.cabinetVeterinaire.nom != 'Phoenix')

    this.AllClients = this.Clients
    this.AllCategoriesAnimal = this.CategoriesAnimal
    this.AllEtablissementVeterinaires = this.EtablissementVeterinaires
    this.loading = false;

    if (!this.nouveau) {
      this.Sacs = (await this._SacService.GetAllSacsByEtablissementId(this.commande.siteCabinet.id)).objet
      this.commande.siteCabinet.CabinetVille = `${this.commande.siteCabinet.cabinetVeterinaire.nom} ${this.commande.siteCabinet.ville}`
      this.commande.animal.dateDeces = new Date(this.commande.animal.dateDeces)

      this.AllStatuts = await (await this._StatutCommandeService.GetAllStatuts()).objet

      this.AllStatuts = this.AllStatuts.filter(
        statut =>
          !this.commande.asso_StatutCommande_Commande
            .some(asso => asso.statutCommandeId == statut.id)
      );

      this.AllStatuts = this.AllStatuts.filter(d => d.id != 6)

      this.StatutSelect = this.AllStatuts[0]

    } else {
      this.Sacs = (await this._SacService.GetAllSacsByEtablissementId(this.AllEtablissementVeterinaires[0].id)).objet
    }

    this.filteredSacs = this.Sacs

    if (!this._GlobalService.isAdmin()) {
      this.lblTypeCremation = "Type de crémation *"
    }

    this.ChargerTableau()
  }

  async AffecterStatut() {

    let data: DataModelUpdateStatutAdmin = new DataModelUpdateStatutAdmin()
    data.commandeId = this.commande.id
    data.statutId = this.StatutSelect.id

    this.loading = true

    let reponse: ReponseAPI = (await this._StatutCommandeService.UpdateStatutCommandeAdmin(data))

    if (reponse.statusCode == 200) {
      this.commande = reponse.objet

      document.location.reload()
    }
    this.loading = false
  }

  async UpdateListeSac(event: SiteCabinetVeterinaire) {

    this.loading = true

    //Aller chercher la liste des sacs de cet établissement
    this.Sacs = (await this._SacService.GetAllSacsByEtablissementId(event.id)).objet

    this.filteredSacs = this.Sacs

    this.loading = false
  }

  ngOnDestroy(): void {
    this._GlobalService.IndexTabCommande = 0
  }

  isCommandeModifiable() {
    return this.commande.asso_StatutCommande_Commande.length < 3
  }
  isCommandeModifiableVeterinaire() {
    return this.commande.asso_StatutCommande_Commande.length < 2
  }

  public async dataStateChange(state: State) {
    this.gridState = state;
    await this.ChargerTableau();
  }
  public async ChargerTableau() {
    // Init des données pour la grille
    this.gridData = process(this.commande.asso_StatutCommande_Commande, this.gridState);
  }

  SuivantCommande() {
    // Naviguer vers l'onglet "Animal"
    if (this.tabstrip) {
      this.IndexTabStrip += 1;
      this.tabstrip.selectTab(this.IndexTabStrip);
    }
  }

  onSelect($event: any) {
    this.tabstrip.selectTab($event.index);
    this.IndexTabStrip = $event.index;
  }

  public isFormValide() {
    this.infoFormSubmit.ngSubmit.emit();

    if (!this.infoFormSubmit.invalid) {
      return true;
    } else {
      return false;
    }
  }

  IsSuivantValide(): boolean {

    if (this.commande.client.nom == "" ||
      this.commande.client.prenom == "" ||
      this.commande.client.telephone == "" ||
      this.commande.client.adresse == "" ||
      this.commande.client.ville == "" ||
      this.commande.client.codePostal == "") {
      return false
    } else {
      return true
    }

  }
  IsSuivantValideCremation(): boolean {
    let retour = false;

    if (this.commande.animal.nom == "" ||
      this.commande.animal.categorieAnimal.id == 0 ||
      this.commande.animal.causeDecesAnimal.id == 0 ||
      this.commande.animal.poids == 0 ||
      this.commande.animal.sexe == "" ||
      (this.commande.isAnimalsuiviCabinet && this.commande.siteCabinet.id == 0)) {
      retour = false;
    }
    else {
      retour = true;
    }
    return retour;
  }

  public validate(): boolean {
    //Faire la logique de validation du type de crémation
    let retour = false;

    if (this.commande.detailCremation.typeCremationInitial.id == 0 || this.commande.detailCremation.sac.id == 0) {
      retour = false;
    }
    else {
      retour = true;
    }
    return retour;
  }

  onFilter(value: string): void {
    const query = value.toLowerCase();
    this.filteredSacs = this.Sacs.filter((sac) =>
      sac.id.toString().toLowerCase().includes(query)
    );


  }

  async EnregistrerCommande() {
    this.loading = true
    let retour = true;
    let reponse: ReponseAPI = new ReponseAPI()

    this.commande.siteCabinet.utilisateurSiteCabinets = null
    this.commande.siteCabinet.commandes = []
    this.commande.siteCabinetId = this.commande.siteCabinet.id
    this.commande.client.role = ""
    this.commande.detailCremation.sac.demandeSac = new DemandeSac()


    reponse = this.nouveau ? await this._CommandeService.AddCommande(this.commande) : await this._CommandeService.UpdateCommande(this.commande);

    if (reponse.statusCode == 200) {
      this.verifFormInformation = true;
      retour = true;
    } else {
      this.verifFormInformation = false;
      this.messageErreurInformation = reponse.messageException;
      retour = false;
    }
    this.loading = false
    return retour
  }

  //#region Filter
  handleFilter(value: any) {
    this.Clients = this.AllClients.filter(
      (client) =>
        (client.PrenomNom)
          .toLowerCase()
          .indexOf(value.toLowerCase()) !== -1
    );
  }

  handleFilterEtablissementveterinaire(value: any) {
    this.EtablissementVeterinaires = this.AllEtablissementVeterinaires.filter(
      etablissement =>
        etablissement.CabinetVille
          .toLowerCase()
          .indexOf(value.toLowerCase()) !== -1
    );
  }
  //#endregion

  isAdministrateur() {
    return this._TokenService.getRoleInToken().toLowerCase() == 'administrateur'
  }

  async SupprimerEtat(event: any) {
    let test: Asso_StatutCommande_Commande = event.dataItem;


    const dialogConfirmCancel = this._dialogService.open({
      title: `Suppression du statut `,
      content: `Voulez-vous vraiment supprimer ce statut ?`,
      actions: [
        { text: 'Annuler', themeColor: 'error' },
        { text: 'Valider', themeColor: 'primary' },
      ]
    });

    dialogConfirmCancel.result.subscribe(async (result) => {
      if (!(result instanceof DialogCloseResult)) {
        if (result.text == "Valider") {
          let reponse = await this._StatutCommandeService.RetirerStatutCommandeAdmin(test);
          if (reponse.statusCode == 200) {
            document.location.reload();
          } else {
            this.messageErreurInformationSupprimerEtat = reponse.messageException;
          }
        } else {
          dialogConfirmCancel.close();
        }
      }
    })

  }

  isStatutRetirable(asso_StatutCommande_Commande: Asso_StatutCommande_Commande) {
    return asso_StatutCommande_Commande.statutCommandeId != 6 && asso_StatutCommande_Commande.statutCommandeId != 1 && !this.commande.isCremationTermine
  }

  AjouterStatut() {
    this.IsAjouterStatut = !this.IsAjouterStatut
  }

}